<template>
    <div id="benefit-display-app">
        <script type="application/javascript"  src="/theme/vue/benefitdisplay/output/benefitDisplay.js"></script>
    </div>
</template>

<script>
  import { formatDate } from '@/utils'

  export default {
    name: 'MemberBenefitTiers',
    props: {
      memberCK: String,
      dos: String,
      authToken: String,
      benefitCategoryId: String,
      memberName: String
    },
    methods: {
      updateBenefits() {
        window.bdEventBus.memberCk = this.memberCK
        window.bdEventBus.memberName = this.memberName
        if (this.$route.query.dateOfService != undefined && this.$route.query.dateOfService != '') {
          // use selected dos takes priority
          window.bdEventBus.dateOfService = formatDate(new Date(this.$route.query.dateOfService + 'T12:00:00-04:00')) // set time to 12pm EST for date string format YYYY-MM-DD
        } else if (this.dos != undefined && this.dos !== '') {
          window.bdEventBus.dateOfService = formatDate(new Date(new Date(this.dos).setHours(12))) // set time to 12pm EST for date string format MM/DD/YYYY
        } else {
          window.bdEventBus.dateOfService = formatDate(new Date())
        }
        window.bdEventBus.moduleId = '301'
        window.bdEventBus.token = this.authToken
        window.bdEventBus.groupCk = ''
        window.bdEventBus.groupId = ''
        window.bdEventBus.groupName = ''
        window.bdEventBus.subGroupId = ''
        window.bdEventBus.subGroupName = ''
        window.bdEventBus.classId = ''
        window.bdEventBus.classPlanId = ''
        window.bdEventBus.selectedBenefitCategory = this.benefitCategoryId
        window.bdEventBus.refreshBenefits()
      }
    },
    mounted() {
      var numTry = 0
      const self = this
      var interval = setInterval(function() {
        if (typeof window.bdEventBus === 'undefined' && typeof bdEventBus === 'undefined') {
          numTry++
          if (numTry < 30) {
            console.log('bdEventBus not detected')
          } else {
            clearInterval(interval)
          }
        } else {
          self.updateBenefits()
          clearInterval(interval)
        }
      }, 200)
    },
    watch: {
      benefitCategoryId(newVal) {
        this.updateBenefits()
      }
    }
  }
</script>

<style>
  @import '../../assets/benefitDisplay.css';
</style>
